import React from 'react'
import PropTypes from 'prop-types'

const InspectionsTopNavbarItem = ({
  children,
  header,
  leftContent = null,
  rightContent = null,
}) => {
  return (
    <React.Fragment>
      <div className="inspections-top-navbar">
        {header || leftContent ? (
          <div className="inspections-top-navbar__left">
            {header ? <span className="header">{header}</span> : null}
            {leftContent ? <div className="header-buttons">{leftContent}</div> : null}
          </div>
        ) : null}
        {rightContent ? <div className="header-buttons">{rightContent}</div> : null}
      </div>
      {children}
    </React.Fragment>
  )
}

InspectionsTopNavbarItem.propTypes = {
  header: PropTypes.string,
  children: PropTypes.node,
  leftContent: PropTypes.node,
  rightContent: PropTypes.node,
}

export default InspectionsTopNavbarItem
